import { createSlice } from '@reduxjs/toolkit';
import { MW_5_14_0 } from '../../constants/migrationVersions';
import { runMigration } from '../../migrations';

export const AIR_AMBULANCE = 'airAmbulance';
export const OBLIQUE_IMAGERY = 'obliqueImagery';
export const TOW_PRO = 'towPro';

// `coordinates` is the latest map click, cleared once a form consumes it.
// `pinnedLocation` is the `{ latitude, longitude }` a form wants marked on the
// map for as long as that location is the one it holds.
const initialState = {
  [AIR_AMBULANCE]: {
    coordinates: null,
    isClickable: false,
    pinnedLocation: null,
  },
  [OBLIQUE_IMAGERY]: {
    coordinates: null,
    isClickable: false,
    pinnedLocation: null,
  },
  [TOW_PRO]: { coordinates: null, isClickable: false, pinnedLocation: null },
};

const geoSelectionSlice = createSlice({
  name: 'geoSelection',
  initialState,
  reducers: {
    setCoordinates: (state, action) => {
      switch (action.payload.key) {
        case AIR_AMBULANCE:
          state[AIR_AMBULANCE].coordinates = action.payload.coordinates;
          state[AIR_AMBULANCE].isClickable = false;
          return;
        case OBLIQUE_IMAGERY:
          state[OBLIQUE_IMAGERY].coordinates = action.payload.coordinates;
          state[OBLIQUE_IMAGERY].isClickable = false;
          return;
        case TOW_PRO:
          state[TOW_PRO].coordinates = action.payload.coordinates;
          state[TOW_PRO].isClickable = false;
          return;
        default:
          return;
      }
    },
    setIsClickable: (state, action) => {
      switch (action.payload.key) {
        case AIR_AMBULANCE:
          state[AIR_AMBULANCE].isClickable = action.payload.isClickable;
          return;
        case OBLIQUE_IMAGERY:
          state[OBLIQUE_IMAGERY].isClickable = action.payload.isClickable;
          return;
        case TOW_PRO:
          state[TOW_PRO].isClickable = action.payload.isClickable;
          return;
        default:
          return;
      }
    },
    setPinnedLocation: (state, action) => {
      switch (action.payload.key) {
        case AIR_AMBULANCE:
          state[AIR_AMBULANCE].pinnedLocation = action.payload.location;
          return;
        case OBLIQUE_IMAGERY:
          state[OBLIQUE_IMAGERY].pinnedLocation = action.payload.location;
          return;
        case TOW_PRO:
          state[TOW_PRO].pinnedLocation = action.payload.location;
          return;
        default:
          return;
      }
    },
    resetState: () => {
      return initialState;
    },
    extraReducers: builder => {
      builder.addCase('APP_INIT_START', state => {
        const migrationList = [MW_5_14_0];
        let newState = { ...state };
        migrationList.forEach(migration => {
          newState = runMigration(newState, 'geoSelection', migration);
        });
        return newState;
      });
    },
  },
});

export const { setCoordinates, setIsClickable, setPinnedLocation, resetState } =
  geoSelectionSlice.actions;

export default geoSelectionSlice.reducer;
